import { BlockEditProps } from "@wordpress/blocks";
import React from "react";
import type { BlockAttributes } from "./block.json";
import {
  InnerBlocks,
  InspectorControls,
  RichText,
  useBlockProps,
  useInnerBlocksProps,
} from "@wordpress/block-editor";
import ImageEditor from "../../../source/components/ImageEditor";
import {
  ToggleControl,
  PanelBody,
  PanelRow,
  TextControl,
} from "@wordpress/components";

const ALLOWED_BLOCKS = ["yellowtree/button"];

export default function CardEditor(props: BlockEditProps<BlockAttributes>) {
  const blockProps = useBlockProps({ className: "d-flex" });
  const innerBlocksProps = useInnerBlocksProps(
    useBlockProps({
      className: "d-flex flex-wrap gap-3 swiper-slide",
    }) as unknown as Record<string, unknown>,
    {
      allowedBlocks: ALLOWED_BLOCKS,
      /*  template: [["yellowtree/button"]], */
    }
  );

  return (
    <>
      <div {...blockProps}>
        <div className="slider-card bg-indigo">
          <div>
            <p className="copy-s mb-4">
              <RichText
                value={props.attributes.caption ?? ""}
                onChange={(newCaption) =>
                  props.setAttributes({ caption: newCaption })
                }
                placeholder="Caption placeholder"
              />
            </p>
            <h2 className="mb-0">
              <RichText
                value={props.attributes.heading ?? ""}
                onChange={(newHeading) =>
                  props.setAttributes({ heading: newHeading })
                }
                placeholder="Heading placeholder"
              />
            </h2>
            <p className="copy-m pt-4">
              <RichText
                value={props.attributes.text ?? ""}
                onChange={(newText) => props.setAttributes({ text: newText })}
                placeholder="Text placeholder"
              />
            </p>
          </div>

          <div className="pt-3 d-flex flex-wrap gap-3 get-button-count">
            <div {...innerBlocksProps} />
          </div>
        </div>
      </div>
    </>
  );
}
